var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "OrderDetcontent" },
    [
      _vm.orderDetail.address
        ? _c(
            "van-row",
            { staticClass: "billDetail" },
            [
              _c(
                "van-col",
                { staticClass: "cont", attrs: { span: "24" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "address", attrs: { span: "24" } },
                    [_vm._v(_vm._s(_vm.orderDetail.address))]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "name", attrs: { span: "12" } },
                    [_vm._v(_vm._s(_vm.orderDetail.name))]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "phone", attrs: { span: "12" } },
                    [_vm._v(_vm._s(_vm.orderDetail.phone))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.orderDetail.status == "0"
                ? _c(
                    "van-col",
                    { staticClass: "statusText", attrs: { span: "24" } },
                    [_vm._v("待接单")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.status == "1,5,6,7"
                ? _c(
                    "van-col",
                    { staticClass: "statusText", attrs: { span: "24" } },
                    [_vm._v("维修中")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.orderDetail.status == "10"
                ? _c(
                    "van-col",
                    { staticClass: "statusText", attrs: { span: "24" } },
                    [_vm._v("已完成")]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.orderDetail.address
        ? _c(
            "van-row",
            { staticClass: "billDetail" },
            [
              _c(
                "van-col",
                { staticClass: "cont", attrs: { span: "24" } },
                [
                  _c("van-col", { attrs: { span: "4" } }, [_vm._v("订单号")]),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "orderId", attrs: { span: "20" } },
                    [_vm._v(_vm._s(_vm.orderDetail.id))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("van-col", { staticClass: "time", attrs: { span: "6" } }, [
                _vm._v("报修时间")
              ]),
              _vm._v(" "),
              _c("van-col", { staticClass: "timeB", attrs: { span: "18" } }, [
                _vm._v(_vm._s(_vm.orderDetail.createTime))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.orderDetail.address
        ? _c(
            "van-row",
            { staticClass: "billDetail" },
            [
              _c(
                "van-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "van-col",
                    { staticClass: "title", attrs: { span: "24" } },
                    [_vm._v("报修描述")]
                  ),
                  _vm._v(" "),
                  _c(
                    "van-col",
                    { staticClass: "reason", attrs: { span: "24" } },
                    [_vm._v(_vm._s(_vm.orderDetail.reason))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-col",
                { staticClass: "imgBox", attrs: { span: "24" } },
                _vm._l(_vm.orderDetail.imageurls, function(img, index) {
                  return _c("img", {
                    key: index,
                    attrs: { src: img, alt: "报修图" },
                    on: {
                      click: function($event) {
                        return _vm.ImagePreviewShow(
                          _vm.orderDetail.imageurls,
                          index
                        )
                      }
                    }
                  })
                }),
                0
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d31e260", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d31e260","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/repairOrder/repairOrderDetail.vue
// module id = null
// module chunks = 